// NPM Imports
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Toastr, Tooltip } from "@revvsales/components";

// Components Imports

import ChartHeader from "../Charts/ChartHeader";
import DashboardLoader from "../DashboardLoader";

// Actions Imports
import DashboardActions from "../../../actions/DashboardActions";
import { filterObjFromArray } from "../../../actions/DashboardActions/dashboardMethods";

// Internal Imports
import { PIPELINE, DASHBOARD } from "../../../constants";
import { OppoUtils, GlobalUtils } from "../../../utils";

// Destructuring
const { getDashboardDocDeals } = DashboardActions;
const { DOCUMENT_STATUS_HASMAP } = PIPELINE;
const { DOCUMENT_TYPES_HASMAP, SALES_OPS, SALES_MGR, SALES_REP } = DASHBOARD;
const { getDocStatusClassName } = OppoUtils;
const { numberForamting, handleApiErrMsg } = GlobalUtils;

class DocumentStatusBoard extends Component {
  state = { showLoader: false };

  componentDidMount() {
    this._onInitData();
  }

  _toggleLoader = flag => {
    this.setState({ showLoader: flag });
  };

  _onInitData = () => {
    const { apiConfigs: { userID, fromDate, toDate } = {} } = this.props;
    this._toggleLoader(true);
    this.props
      .getDashboardDocDeals(userID, fromDate, toDate)
      .then(() => {
        this._toggleLoader(false);
      })
      .catch(error => {
        console.error(
          `DocumentStatusBoard(index.js) => _onInitData => ${error}`,
        );
        this._toggleLoader(false);
        Toastr.showToastr({
          type: "failure",
          message: handleApiErrMsg(error),
          timeout: 3000,
        });
      });
  };

  _getTotalDocData = pipelineDocs => {
    const docTotal = {
      count: 0,
      dealValue: 0,
    };
    pipelineDocs.forEach(docStatus => {
      docTotal.count += docStatus.frequency;
      docTotal.dealValue += docStatus.dealValue;
    });

    return docTotal;
  };

  _docDealAndStatusBox = (frequency, status, dealValue) => (
    <div className="documentstatusboard-itemsbox">
      <span
        className={`documentstatusboard-${getDocStatusClassName(
          status,
        )} documentstatusboard-itemsbox-status`}>
        {DOCUMENT_STATUS_HASMAP[status]
          ? DOCUMENT_STATUS_HASMAP[status].toLowerCase()
          : null}
      </span>
      <div className="documentstatusboard-itemsbox-count">{frequency}</div>
      <div className="documentstatusboard-itemsbox-decription">
        {`${numberForamting(dealValue, "$")}`}
      </div>
    </div>
  );

  _deviceDocStatusRightSec = (userType, totalDeal) => {
    switch (userType) {
      case SALES_REP:
        return this._salesRepDocRightSec(totalDeal);
      case SALES_MGR:
        return this._salesManDocRightSec(this.props.documentTyes);
      case SALES_OPS:
        return this._salesManDocRightSec(this.props.documentTyes);
      default:
        return null;
    }
  };

  _salesManDocRightSec = documentTyes => (
    <div className="documentstatusboard-right-secwrapper">
      {documentTyes.map(type => (
        <div className="documentstatusboard-right-textwrapper" key={type.name}>
          <span className="documentstatusboard-right-number">
            {type.frequency}
          </span>
          <Tooltip placement="top" overlay={type.name}>
            <span className="documentstatusboard-right-text">
              {DOCUMENT_TYPES_HASMAP[type.name] &&
                DOCUMENT_TYPES_HASMAP[type.name]}
            </span>
          </Tooltip>
        </div>
      ))}
    </div>
  );

  _salesRepDocRightSec = totalDeal => (
    <div className="documentstatusboard-itemsbox">
      <div className="documentstatusboard-itemsbox-count">
        {`${numberForamting(totalDeal, "$")}`}
      </div>
      <div className="documentstatusboard-itemsbox-decription">
        Deal Size currently in Pipeline
      </div>
    </div>
  );

  _getDocStatusFooter = (showFooter, dealValue, achievedValue) => {
    if (showFooter) {
      return (
        <div className="documentstatusboard-footer">
          <div className="documentstatusboard-footer-itembox">
            <span className="documentstatusboard-footer-itemtitle">
              Net Value in Pipeline
            </span>
            <span className="documentstatusboard-footer-itemvalue">
              {numberForamting(dealValue, "$")}
            </span>
          </div>
          <div className="documentstatusboard-footer-itembox">
            <span className="documentstatusboard-footer-itemtitle">
              Deal Value Closed
            </span>
            <span className="documentstatusboard-footer-itemvalue">
              {numberForamting(achievedValue, "$")}
            </span>
          </div>
          {/* <div className="documentstatusboard-footer-itembox">
            <span className="documentstatusboard-footer-itemtitle">
              Difference
            </span>
            <span className="documentstatusboard-footer-itemvalue danger-color">
              $134,880
            </span>
          </div>
          <div className="documentstatusboard-footer-itembox">
            <span className="documentstatusboard-footer-itemtitle">
              Target Value
            </span>
            <span className="documentstatusboard-footer-itemvalue">
              $2,000,000
            </span>
          </div> */}
        </div>
      );
    }
    return null;
  };

  _getTextNumberBox = (icon, title, value, count, isLable, labelClassName) => (
    <div
      className="documentstatusboard-itemsbox-wrapper first-itemsbox-wrapper itemsbox-totalcount"
      key={title}>
      {icon ? (
        <div className="documentstatusboard-itemsbox-icon documentstatusboard-itemsbox-documenticon">
          <FontAwesomeIcon icon={["fas", `${icon}`]} />
        </div>
      ) : null}

      <div className="documentstatusboard-itemsbox">
        {isLable ? (
          <span
            className={`documentstatusboard-${labelClassName} documentstatusboard-itemsbox-status`}>
            {title}
          </span>
        ) : (
          <span className="documentstatusboard-itemsbox-decription">
            {title}
          </span>
        )}

        <div
          className={`documentstatusboard-itemsbox-count ${
            !isLable ? "large-font" : ""
          }`}>
          {count}
        </div>
        <div className="documentstatusboard-itemsbox-decription">
          {numberForamting(value, "$")}
        </div>
      </div>
    </div>
  );

  _getDocStatusBoxes = pipelineDocs =>
    pipelineDocs.map(docStatus => {
      const labelClassName = getDocStatusClassName(docStatus.status);
      const title = DOCUMENT_STATUS_HASMAP[docStatus.status]
        ? DOCUMENT_STATUS_HASMAP[docStatus.status].toLowerCase()
        : null;

      return this._getTextNumberBox(
        null,
        title,
        docStatus.dealValue,
        docStatus.frequency,
        true,
        labelClassName,
      );
    });

  /**
   * Decide the Pipeline Overview Boxes based on the following user roles -
   * 1. SalesOps or
   * 2. SaleMgrm or
   * 3. SalesRep
   */
  _decideDocBoxByUserType = (userType, pipelineDocs, documentTyes) => {
    const docTotal = this._getTotalDocData(pipelineDocs);
    if (userType === SALES_REP) {
      return (
        <Fragment>
          {this._getTextNumberBox(
            "file-alt",
            "Docs in Pipeline",
            docTotal.dealValue,
            docTotal.count,
            false,
          )}
          <div className="documentstatusboard-itemsbox-wrapper second-itemsbox-wrapper itembox-lborder">
            {this._getDocStatusBoxes(pipelineDocs)}
          </div>
          <div className="documentstatusboard-itemsbox-wrapper third-itemsbox-wrapper itembox-lborder">
            {this._deviceDocStatusRightSec(userType, docTotal.dealValue)}
          </div>
        </Fragment>
      );
    }
    return (
      <div className="documentstatusboard-doc-salesops-row">
        <div className="documentstatusboard-doc-salesops-col salesops-docst-col-1">
          <div className="documentstatusboard-textnumber-wrapper">
            {this._getTextNumberBox(
              "file-alt",
              "Docs in Pipeline",
              docTotal.dealValue,
              docTotal.count,
              false,
            )}
          </div>
          <div className="documentstatusboard-docright-wrapper">
            {this._salesManDocRightSec(documentTyes)}
          </div>
        </div>
        <div className="documentstatusboard-doc-salesops-col salesops-docst-col-2">
          {this._getDocStatusBoxes(pipelineDocs)}
        </div>
      </div>
    );
  };

  /**
   * Decide the Pipeline Overview
   */
  _getView = userType => {
    const { pipelineDocs, dealCounts, documentTyes } = this.props;
    const showFooter = userType !== SALES_REP;
    const docTotal = this._getTotalDocData(pipelineDocs);
    const approvedDeals = filterObjFromArray(
      dealCounts,
      "name",
      "DOCUMENT_CLIENT_APPROVED",
    )[0];
    const achievedValue = approvedDeals ? approvedDeals.value : 0;
    return (
      <Fragment>
        <ChartHeader
          title="Pipeline Overview"
          dateTitle="Jan 01, 2019 July 01, 2019"
        />
        {/* Dashboard Document Status Main Section */}
        <div className="documentstatusboard-container">
          {this._decideDocBoxByUserType(userType, pipelineDocs, documentTyes)}
        </div>
        {/* Dashboard Document Status Footer */}
        {this._getDocStatusFooter(
          showFooter,
          docTotal.dealValue,
          achievedValue,
        )}
      </Fragment>
    );
  };

  render() {
    const { apiConfigs: { userRole: { name: userType } } = {} } = this.props;
    if (this.state.showLoader) {
      return <DashboardLoader message="loading document deals" />;
    }
    return <Fragment>{this._getView(userType)}</Fragment>;
  }
}

const mapStateToProps = state => {
  const { pipelineDocs, dealCounts, documentTyes } = state.DashboardStore;
  return { pipelineDocs, dealCounts, documentTyes };
};

const mapDispatchToProps = {
  getDashboardDocDeals: (userID, fromDate, toDate) =>
    getDashboardDocDeals(userID, fromDate, toDate),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DocumentStatusBoard);



// WEBPACK FOOTER //
// ./src/components/DashboardWrapper/DocumentStatusBoard/index.js